<template>
  <b-modal
    id="announcement-modal"
    ref="modal"
    :title="title"
    @hidden="onClose"
    @show="onShow"
    size="md"
  >
    <ValidationObserver
      ref="announcementForm"
      tag="form"
      @submit.prevent="onSubmit"
      id="announcementForm"
    >
      <div class="form-row form-group">
        <label class="col-lg-2 col-form-label text-lg-right">Tablica:</label>
        <div class="bv-no-focus-ring col">
          <input
            type="text"
            class="title-input"
            :value="board==='subcontractor'?'Podwykonawcy':'Pracownicy'"
            readonly="true"
          />
        </div>
      </div>
      <b-form-group label-cols-lg="2" label="Rodzaj:" label-for="variant" label-align-lg="right">
        <ValidationProvider name="variant" rules="required" v-slot="validationContext">
          <b-form-select id="variant" :value="null" v-model="form.variant" :options="variant"></b-form-select>
          <b-form-invalid-feedback :force-show="true">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </b-form-group>

      <b-form-group label-cols-lg="2" label label-for="checkbox" label-align-lg="right">
        <b-form-checkbox
          id="checkbox"
          v-model="form.pinned"
          name="checkbox"
          value="1"
          unchecked-value="0"
        >Przypnij ogłoszenie</b-form-checkbox>
      </b-form-group>

      <ValidationProvider name="textarea" rules="required|min:2" v-slot="validationContext">
        <b-form-group class="mb-0" label="Treść ogłoszenia:" label-for="textarea">
        <b-form-textarea
          type="text"
          id="textarea"
          v-model="form.content"
          placeholder="Wpisz treść ogłoszenia..."
          rows="5"
          max-rows="10"
        ></b-form-textarea>
         </b-form-group>
        <b-form-invalid-feedback :force-show="true">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
      </ValidationProvider>
    </ValidationObserver>
    <template v-slot:modal-footer="{cancel}">
      <b-button size="md" variant="primary" type="submit" form="announcementForm">Zapisz</b-button>
      <b-button size="md" variant="outline-danger" @click="cancel()">Anuluj</b-button>
    </template>
  </b-modal>
</template>

<script>
import AnnouncementsService from "@/services/announcements.service";

const announcementForm = {
  variant: "primary",
  pinned: "0",
  content: ""
};

export default {
  name: "AnnouncementModalForm",
  props: {
    announcement: {
      type: Object,
      default: () => {
        return {};
      }
    },
    board: {
      type: String
    }
  },
  data() {
    return {
      form: {
        board: "subcontractor",
        variant: "primary",
        pinned: "0",
        content: ""
      },

      variant: [
        { value: "primary", text: "Główny" },
        { value: "secondary", text: "Poboczny" },
        { value: "success", text: "Sukces" },
        { value: "danger", text: "Niebezpieczeństwo" },
        { value: "warning", text: "Ostrzeżenie" }
      ]
    };
  },
  computed: {
    title() {
      return this.$_.isEmpty(this.announcement) === false
        ? "Edytuj ogłoszenie"
        : "Dodaj nowe ogłoszenie";
    },
    isEdited() {
      return this.$_.isEmpty(this.announcement) === false;
    }
  },
  methods: {
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onShow() {
      if (this.isEdited === true) {
        this.$_.each(announcementForm, (value, key) => {
          this.form[key] = this.announcement[key];
        });
      } else {
        this.$_.each(announcementForm, (value, key) => {
          this.form[key] = value;
        });
      }

      this.form.board = this.board;
    },
    onClose() {
      this.$_.each(announcementForm, (value, key) => {
        this.form[key] = value;
      });
      // this.$emit("onClose");
    },
    onSubmit() {
      this.$refs.announcementForm.validate().then(success => {
        if (!success) {
          return;
        }
        this.$Progress.start();
        if (this.isEdited) {
          //-- EDITED
          AnnouncementsService.update(this.announcement.id, this.form)
            .then(data => {
              this.$emit("onSubmit", data);
            })
            .catch(error => {
              this.$refs.announcementForm.setErrors(error.response.data.fields);
            });
        } else {
          //-- CREATE NEW
          AnnouncementsService.create(this.form)
            .then(data => {
              this.$emit("onSubmit", data, true);
              this.$nextTick(() => {
                this.$bvModal.hide("announcement-modal");
              });
            })
            .catch(error => {
              if (error.response.data && error.response.data.fields) {
                this.$refs.announcementForm.setErrors(
                  error.response.data.fields
                );
              }
            });
        }
      });
    }
  }
};
</script>